// See https://gist.github.com/danharper/ad6ca574184589dea28d
// Similar to the CancellationToken API from C#

import {EventDispatcher} from "diy/util/event";

// Computed method names to prevent them from being publicly accesible
const CANCEL = "_symbol_shim_cancel_"; //Symbol();
const REGISTER = "_symbol_shim_register_"; //Symbol();

export class OperationCanceledError extends Error {
    constructor(public cancellationToken: CancellationToken) {
        super();

        // This fixes instanceof
        Object.setPrototypeOf(this, OperationCanceledError.prototype);
    }
}

export class CancellationToken {
    private cancelled = false;

    /**
     * Shouldn't be instantiated directly, but through a CancellationTokenSource
     */
    constructor(private source: CancellationTokenSource) {

    }

    /**
     * Throws an OperationCanceledError if the token is in cancelled state
     */
    throwIfCancelled() {
        if (this.isCancelled()) {
            throw new OperationCanceledError(this);
        }
    }

    isCancelled() {
        return this.cancelled === true;
    }

    /** Internal method callable only from CancellationTokenSource */
    [CANCEL]() {
        this.cancelled = true;
    }

    /**
     * Registers a callback to be called when the token is cancelled.
     * If the token is already in cancelled state, the callback is immediately invoked
     */
    register(callback: () => void) {
        (this.source as any)[REGISTER](callback);
    }
}

export class CancellationTokenSource {
    public token: CancellationToken;
    private onCancel = new EventDispatcher<this, void>();

    constructor() {
        this.token = new CancellationToken(this);
    }

    /**
     * Issues token cancellation and notifies any registered callbacks
     */
    cancel() {
        (this.token as any)[CANCEL]();
        this.onCancel.dispatch(this, void 0);
    }

    /**
     * Internal method only callable from CancellationToken
     */
    [REGISTER](callback: () => void) {
        this.onCancel.subscribe(() => callback());
        if (this.token.isCancelled()) {
            callback();
        }
    }

    /**
     * Free used resources for garbage collection
     */
    dispose() {
        this.token = void 0;
        this.onCancel = void 0;
    }
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/util/task/cancellation.ts
 **/